import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';

@NgModule({
    imports: [
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      NgZorroAntdModule
    ],
    exports: [
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      NgZorroAntdModule
    ]
  })
  export class FcshareModule {
  }